import React from 'react';
import { ArrowLeft, Share2 } from 'lucide-react';
import { isColorDark } from '../utils';

const SiteHeader = ({ shop, slug, navigate, onShare, theme }) => (
  <header className="sticky top-0 z-50" style={{ backgroundColor: theme.headerColor, borderBottom: `1px solid ${theme.borderColor}` }}>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between h-16">
        <button 
          onClick={() => navigate(`/s/${slug}`)}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-5 h-5" style={{ color: theme.mutedText }} />
          <div className="flex items-center gap-2.5">
            {shop.logoUrl ? (
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}${shop.logoUrl}`}
                alt={shop.name}
                className="w-8 h-8 rounded-lg object-cover"
              />
            ) : (
              <div 
                className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-sm font-bold"
                style={{ backgroundColor: theme.accentColor }}
              >
                {shop.name.charAt(0)}
              </div>
            )}
            <span className="font-semibold text-sm sm:text-base" style={{ color: isColorDark(theme.headerColor) ? '#fff' : '#111' }}>{shop.name}</span>
          </div>
        </button>
        <div className="flex items-center gap-2">
          <button 
            onClick={onShare}
            className="p-2 rounded-full transition-colors"
            style={{ color: theme.mutedText }}
            data-testid="share-btn"
          >
            <Share2 className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  </header>
);

export default SiteHeader;
